import "./add.css"
import './details.css'
import './print.css'
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { Item, ItemService } from '../../services/Item';
import TableDetailsWrapper from "./tableDetails/tableDetailsWrapper";
import QuillEditorReadOnly from "../quillEditor/quillEditorReadOnly";
import { PrinterOutlined } from '@ant-design/icons';
import { Button, Space } from "antd";
import { Country } from "../../services/Country";
import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Spin } from 'antd';
import ProcessFlow from "../processFlow/processFlow";

function PrintPreview() {

    const params = useParams();
    const [items, setItems] = useState<Item[]>();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (params.country) {
            getItems(params.country)
        } else {
            setItems(undefined);
            setLoading(false);
        }

    }, [params.id])

    const getItems = async (country: string) => {
        const { data } = await ItemService.getAll(country);
        setItems(data)
        setLoading(false);
    }
    const printDetails = () => {
        window.print();
    }


    return (
        <>
            {loading ? (
                <Flex style={{height:'80vh', justifyContent: 'center', alignItems:'center'}}>
                    <Spin indicator={<LoadingOutlined spin />} size="large" />
                </Flex>
            ) :
                (
                    <div style={{ padding: 32 }}>
                        <Space>
                            <h1>Standard Operating Procedures, {items ? (items[0]?.country as Country).name : ''}</h1>
                            <Button onClick={printDetails} type="primary" icon={<PrinterOutlined />} className="print-all-button">Print</Button>
                        </Space>
                        <div className='menu-print'>
                            {items?.map((item, index) => <div key={item._id}>
                                <div className='item-title-print'>
                                    {index + 1} {item.title}
                                </div>
                                <div>
                                    {item.children.map((subtitle, index2) => <div className='item-subtitle-print' key={index2}>
                                        {index + 1}.{index2 + 1} {subtitle.title}
                                    </div>)}
                                </div>
                            </div>)}
                        </div>

                        {items?.map((item, index) => <div key={item._id}>
                            <h1>{index + 1} {item.title}</h1>
                            {item?.itemType === 'content' && <QuillEditorReadOnly item={item} />}
                            {item?.itemType === 'table' && <div>
                                <TableDetailsWrapper item={item} />
                                <ProcessFlow item={item} />
                            </div>
                            }
                            <div>
                                {item.children.map((subtitle, index2) => <div key={index2}>
                                    <h2>{index + 1}.{index2 + 1} {subtitle.title}</h2>
                                    {(subtitle.children as Item)?.itemType === 'content' && <QuillEditorReadOnly item={(subtitle.children as Item)} />}
                                    {(subtitle.children as Item)?.itemType === 'table' && <div>
                                        <TableDetailsWrapper item={(subtitle.children as Item)} />
                                        <ProcessFlow item={(subtitle.children as Item)} />
                                    </div>
                                    }
                                </div>)}
                            </div>
                        </div>)}
                    </div>
                )
            }
        </>
    );
}

export default PrintPreview;